module.exports = "/dist/3917e9d99675f49bc9b8c53180759a62.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400italic.eot
// module id = 13
// module chunks = 0